<div class="inventory-wrapper">
  <app-device-flasher
    (newDevice)="selectDevice($event)"
    [flasherType]="'inventory'"
    [nbFlashedDevices]="nbFlashedDevices"
  ></app-device-flasher>

  @if (displayDevice) {
    <ul class="inventory-list">
      @for (key of getKeys(displayDevice); track key) {
        <li class="inventory-item">
          <p class="inventory-item-title">{{ NAME_TABLE[key] || key }}</p>
          @if (key !== 'battery') {
            <p class="inventory-item-value">
              {{ displayDevice[key] }}
            </p>
          }
          @if (key === 'battery') {
            <img
              class="inventory-item-img"
              [src]="displayDevice[key]"
              />
          }
        </li>
      }
    </ul>
  }
</div>

@if (disassemblyBtn) {
  <div class="footerCustom">
    <mat-divider></mat-divider>
    <button matButton class="btnAction" (click)="goToDisassemble()">
      PROCEED TO DISASSEMBLY
    </button>
  </div>
}
